import styles from "@/styles/productReviews.module.scss";
import { useState } from "react";
import TabBar from "@/components/TabBar";
import ReviewImages from "./components/ReviewImages";
import CustomerReviews from "../productDetail/ProductReviews/CustomerReviews";
import ReviewProductDetail from "./components/ReviewProductDetail";
import SimilarProducts from "./components/SimilarProducts";
import { Button, Image } from "antd";
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
interface PictureItem {
  thumbnailUrl: string;
  imageHDUrl: string;
  imageORUrl: string;
  fileNameUrl: string;
  isDefault: number;
}

interface ProductItem {
  productID: number;
  name: string;
  url: string;
  imgUrl?: string;

  thumbnail?: string;
  smallThumbnail?: string;
  newThumbnail?: string;
  filename?: string;

  price: number;
  normalPrice: number;

  isGroup: number;
  inStock: number;
  preSales: number;

  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  isEmailOnly: any,
  promotionTypeID: number;

  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    pointRate: string;
    promotionRate: number;
  };
  review: {
    avgRank: number;
    total: number;
  };

  [key: string]: any;
}

interface Props {
  productId: string;
  courierID: number;
  pictures: PictureItem[];
  productList: ProductItem[];
  productUrl: string;
  reviewCount: number | string;
  onTabChange: (index: number) => void;
}
export default function ReviewDetails({
  productId,
  courierID,
  pictures,
  productList,
  productUrl,
  reviewCount,
  onTabChange,
}: Props) {
  const tabList = [
    { id: 1, name: `Customer Reviews(${reviewCount})` },
    { id: 2, name: `Images(${pictures.length})` },
    { id: 3, name: "Product Details" },
    { id: 4, name: "Similar Products" },
  ];
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (index: number) => {
    setActiveTab(index);
    onTabChange(index);
  };

  return (
    <div className={styles["reviews-section"]}>
      <div className={styles["reviews-tab"]}>
        <TabBar
          tabList={tabList}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />

        {/* Customer Reviews */}
        {activeTab === 0 && productId && (
          <CustomerReviews productID={productId} hideDetail={true} hideTopPage={true} ReviewEmptyComponent={() => <ReviewEmptyComponent productID={productId} />} />
        )}

        {/* Images */}
        {activeTab === 1 && <ReviewImages pictures={pictures} />}

        {/* Product Details */}
        {activeTab === 2 && (
          <ReviewProductDetail courierID={courierID} productId={productId} productUrl={productUrl} />
        )}

        {/* Similar Products */}
        {activeTab === 3 && <SimilarProducts productList={productList} />}
      </div>
    </div>
  );
}

const ReviewEmptyComponent = ({ productID }: any) => (
  <div className={styles['review-empty']}>
    <div className={styles['review-empty-img']}>
      <Image src={`${imageDomain}/customerReviews.png`} width={225} preview={false} />
    </div>
    <div className={styles['review-empty-title']}>
      {'Share your review and photos here.'}<br />
      {'And 100-200 crazypoints will be rewarded after the review approved.'}
    </div>
    <div className={styles['review-empty-title']} style={{ color: '#333333', marginTop: '4px' }}>{'(100 CrazyPoints Equals to $1)'}</div>
    <div className={styles['review-empty-desc']}>{'Note: You will get double CrazyPoints if your review is one of the first three approved!'}</div>
    <div className={styles['review-empty-btn']}>
      <Button href={`/review/write-review/${productID}`} type="primary" style={{ width: '240px', fontWeight: 'bold' }}>Write a Review</Button>
    </div>
  </div>
)
